import axios from "@/plugins/axios.js"
import api from "@/api.js"
export default class TechnicalService{
	constructor(){
		this.listTechnicals = [];
	}
	getTechnicals(){
		return this.listTechnicals;
	}
	async getList(){		
		try{
			if (api) {

				const uri = `${api.url}/api/v1/workspace/state`;
				const data = await axios.post(uri,{manager_id : "my_computer"});
				return data;
			}
		}catch(er){
			console.warn("Error get TechnicalService ", er)
			return er;
		}
		return null;
	}
}